var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
var BaseGridCell = function (props) {
    var UI = useControllers().UI;
    var p = useProps(props);
    var s = useStore(function () { return ({
        get style() {
            var columns = p.columns, rows = p.rows, columnStart = p.columnStart, columnEnd = p.columnEnd, rowStart = p.rowStart, rowEnd = p.rowEnd, area = p.area, alignSelf = p.alignSelf, justifySelf = p.justifySelf;
            return {
                gridArea: area,
                '--grid-column-end': typeof columns === 'number' ? 'span ' + columns : undefined,
                '--row-column-end': rows ? 'span ' + rows : undefined,
                gridColumnStart: columnStart || (columns === 'all' && 'grid-column-start'),
                gridColumnEnd: columnEnd || (columns === 'all' && 'grid-column-end'),
                gridRowStart: rowStart,
                gridRowEnd: rowEnd,
                alignSelf: alignSelf,
                justifySelf: justifySelf,
                flexBasis: UI.cssFeatures.grid ? undefined : columns === 'all' ? '100%' : columns ? 1 / columns * 100 + '%' : undefined,
            };
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName("BaseGridCell", p.className), style: __assign(__assign({}, s.style), p.style) }, props.children)); } });
};
export default BaseGridCell;
